module.exports = __webpack_public_path__ + "img/indicador_calidad_datos_hover.99d515e1.png";